__turbopack_context__.v({
  "avatar": "AddShareTypeaheadItem-module__k2I1XG__avatar",
  "detail": "AddShareTypeaheadItem-module__k2I1XG__detail",
  "item": "AddShareTypeaheadItem-module__k2I1XG__item",
  "text": "AddShareTypeaheadItem-module__k2I1XG__text",
});
